const steps = [
  {
    number: '01',
    icon: 'ri-user-search-line',
    badge: 'Research & Strategy',
    title: 'Аналитика и смысловая архитектура',
    intro: 'Начинаем не с подбора слов, а с глубокого изучения фундамента вашего бизнеса.',
    points: [
      {
        label: 'Изучение ЦА',
        text: 'Определяем «лицо» вашего клиента, его привычки, потребности и критерии выбора. Это позволяет избежать распыления бюджета на нецелевых пользователей.',
      },
      {
        label: 'Сегментирование ЦА',
        text: 'Разделяем клиентов на группы со схожими свойствами (кластеризация), чтобы сформировать предложение, максимально точно отвечающее запросам каждого сегмента.',
      },
      {
        label: 'Карта персонажей',
        text: 'Создаём детальный портрет (аватар) для каждого сегмента. Выявляем основные «боли», страхи и факторы принятия решения: цена, сервис, география.',
      },
      {
        label: 'Проектирование оффера',
        text: 'На основе карты персонажей формулируем выгоды, которые бьют точно в цель. Каждая потребность клиента превращается в конкретную выгоду в объявлении.',
      },
    ],
    deliverable: 'Карта персонажей, конкурентный анализ, смысловая архитектура кампании.',
    color: 'bg-[#1A2B4C]',
  },
  {
    number: '02',
    icon: 'ri-funds-line',
    badge: 'Media Planning',
    title: 'Стратегический медиаплан',
    intro: 'Рассчитываем финансовые показатели будущего запуска.',
    points: [
      {
        label: 'Прогноз бюджета',
        text: 'Определяем необходимую сумму для охвата целевой аудитории в поиске и сетях (РСЯ / КМС) на основе реальных рыночных данных.',
      },
      {
        label: 'Реперные точки (KPI)',
        text: 'Рассчитываем планируемый CTR, среднюю цену клика (CPC) и прогнозируемую конверсию в лид.',
      },
      {
        label: 'Расчёт стоимости лида',
        text: 'Вы заранее видите примерный уровень затрат на получение одной заявки, исходя из рыночных данных и нашего опыта.',
      },
    ],
    deliverable: 'Медиаплан с прогнозом бюджета, KPI и ожидаемой ценой лида.',
    color: 'bg-[#253D6B]',
  },
  {
    number: '03',
    icon: 'ri-settings-3-line',
    badge: 'Pre-launch',
    title: 'Подготовка к запуску рекламы',
    intro: 'Техническая и смысловая проработка всех элементов кампании.',
    points: [
      {
        label: 'Сбор семантического ядра',
        text: 'Собираем базовые и вложенные ключевые запросы, которые используют ваши клиенты. Тщательно прорабатываем минус-слова, чтобы отсечь мусорный трафик.',
      },
      {
        label: 'Создание продающих объявлений',
        text: 'Пишем по модели «Выгода + Идентификация + Свойства продукта + Призыв к действию». Используем конкретные цифры, выгоды и ваше УТП.',
      },
      {
        label: 'Техническая проработка',
        text: 'Заполняем все доступные расширения: быстрые ссылки, уточнения, видимый URL, визитки. Это делает объявление визуально больше и напрямую повышает «Показатель качества».',
      },
    ],
    deliverable: 'Готовые объявления, семантическое ядро с минус-словами, структура кампании.',
    color: 'bg-[#1A2B4C]',
  },
  {
    number: '04',
    icon: 'ri-dashboard-3-line',
    badge: 'Analytics & Launch',
    title: 'Веб-аналитика и запуск',
    intro: 'Каждое объявление размечается — мы знаем, откуда пришёл каждый рубль.',
    points: [
      {
        label: 'UTM-разметка',
        text: 'Каждое объявление получает специальные метки. Мы точно знаем, с какого объявления, ключевого слова и региона пришёл покупатель.',
      },
      {
        label: 'Настройка аналитики',
        text: 'Убеждаемся, что на сайте установлены и корректно работают счётчики Google Analytics 4 и Яндекс.Метрика, настроены цели конверсии.',
      },
    ],
    deliverable: 'Полная UTM-разметка, настроенные счётчики, цели конверсии.',
    color: 'bg-[#253D6B]',
  },
  {
    number: '05',
    icon: 'ri-robot-2-line',
    badge: 'AI Optimization',
    title: 'Продвинутые технологии и аналитика запущенных кампаний',
    intro: 'Управляем маркетингом на основе твёрдых данных — запуск это только начало.',
    points: [
      {
        label: 'Оптимизация на основе ИИ',
        text: 'Используем автоматизированные стратегии и собственные ИИ-скрипты для управления ставками. Система сама находит, в какие часы и по каким фразам приходят самые «дешёвые» клиенты.',
      },
      {
        label: 'Еженедельная докрутка',
        text: 'Контекстная реклама требует постоянного внимания. Мы чистим площадки, тестируем новые заголовки и масштабируем то, что приносит деньги. Ищем очевидные ошибки, оптимизируем охват и улучшаем тексты объявлений (конвертеры).',
      },
      {
        label: 'Отчётность',
        text: 'Строим отчёты по источникам, кампаниям, конкретным ключевым словам и целевым страницам. Анализируем аудиторию: какие регионы, возрастные группы и пол приносят больше всего реальных продаж.',
      },
    ],
    deliverable: 'Снижение CPA, рост конверсий, прозрачная еженедельная отчётность по каждому рублю.',
    color: 'bg-[#1A2B4C]',
  },
];

export default function ContextAdsProcess() {
  return (
    <section id="context-ads-process" className="py-12 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1A2B4C]/08 border border-[#1A2B4C]/15 mb-5">
            <i className="ri-route-line text-[#C5A880] text-sm"></i>
            <span className="text-[#1A2B4C] text-xs font-bold font-['Montserrat'] uppercase tracking-widest">
              Системный подход
            </span>
          </div>
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-4 leading-tight">
            {/* Мобильная версия — 4 строки */}
            <span className="sm:hidden">
              Как мы работаем:<br />
              процесс запуска<br />
              рекламной кампании<br />
              по шагам
            </span>
            {/* Десктоп версия — 2 строки */}
            <span className="hidden sm:inline">
              Как мы работаем: процесс запуска
              <span className="block mt-1">рекламной кампании по шагам</span>
            </span>
          </h2>
          <div className="w-16 h-1 bg-[#C5A880] mx-auto mb-5 rounded-full"></div>
          <p className="text-sm sm:text-base text-gray-600 max-w-3xl mx-auto leading-relaxed font-['Montserrat'] text-justify sm:text-center">
            Мы подходим к запуску системно, чтобы каждый вложенный рубль работал на результат.
            Мы работаем по системе <strong>глубокого маркетингового погружения</strong>, а не просто «закидываем ключи в кабинет».
          </p>
        </div>

        <div className="space-y-3 sm:space-y-5">
          {steps.map((step) => (
            <div key={step.number} className={`${step.color} rounded-2xl sm:rounded-3xl overflow-hidden`}>
              <div className="p-4 sm:p-8">
                {/* Mobile header */}
                <div className="flex items-center gap-3 mb-3 sm:hidden">
                  <div className="w-10 h-10 rounded-xl bg-[#C5A880]/20 border border-[#C5A880]/30 flex items-center justify-center flex-shrink-0">
                    <i className={`${step.icon} text-lg text-[#C5A880]`}></i>
                  </div>
                  <div>
                    <span className="text-[#C5A880] text-xs font-bold font-['Montserrat'] uppercase tracking-wider block">
                      Шаг {step.number} — {step.badge}
                    </span>
                    <h3 className="text-sm font-bold text-white font-['Playfair_Display'] mt-0.5 leading-snug">
                      {step.title}
                    </h3>
                  </div>
                </div>

                {/* Desktop layout */}
                <div className="hidden sm:flex items-start gap-6">
                  <div className="flex-shrink-0 w-14 h-14 rounded-xl bg-[#C5A880]/20 border border-[#C5A880]/30 flex items-center justify-center">
                    <i className={`${step.icon} text-2xl text-[#C5A880]`}></i>
                  </div>
                  <div className="flex-shrink-0 w-56">
                    <span className="inline-block px-3 py-1 rounded-full bg-[#C5A880]/20 border border-[#C5A880]/30 text-[#C5A880] text-xs font-semibold font-['Montserrat'] mb-2">
                      Шаг {step.number} — {step.badge}
                    </span>
                    <h3 className="text-base font-bold text-white font-['Playfair_Display'] leading-snug">
                      {step.title}
                    </h3>
                    <p className="text-white/50 text-xs font-['Montserrat'] mt-1 italic leading-relaxed">
                      {step.intro}
                    </p>
                  </div>
                  <div className="hidden sm:block w-px h-16 bg-white/15 flex-shrink-0 mt-1"></div>
                  <div className="flex-1 space-y-2.5">
                    {step.points.map((pt, pi) => (
                      <div key={pi} className="flex items-start gap-2">
                        <span className="text-[#C5A880] text-xs font-bold font-['Montserrat'] flex-shrink-0 w-40 leading-snug mt-0.5">
                          {pt.label}:
                        </span>
                        <p className="text-white/75 text-xs sm:text-sm leading-relaxed font-['Montserrat'] text-justify flex-1">
                          {pt.text}
                        </p>
                      </div>
                    ))}
                    <div className="flex items-start gap-2 border-t border-white/10 pt-2">
                      <span className="text-[#C5A880] text-xs font-bold font-['Montserrat'] flex-shrink-0 w-20 mt-0.5">Результат:</span>
                      <p className="text-white/60 text-xs leading-relaxed font-['Montserrat'] italic flex-1">
                        {step.deliverable}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Mobile content */}
                <div className="sm:hidden space-y-2">
                  <p className="text-white/50 text-xs font-['Montserrat'] italic mb-2">{step.intro}</p>
                  {step.points.map((pt, pi) => (
                    <div key={pi}>
                      <span className="text-[#C5A880] text-xs font-bold font-['Montserrat'] block mb-1">{pt.label}:</span>
                      <p className="text-white/75 text-xs leading-relaxed font-['Montserrat'] text-justify">{pt.text}</p>
                    </div>
                  ))}
                  <div className="border-t border-white/10 pt-2">
                    <span className="text-[#C5A880] text-xs font-bold font-['Montserrat'] block mb-1">Результат:</span>
                    <p className="text-white/60 text-xs leading-relaxed font-['Montserrat'] italic">{step.deliverable}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 sm:mt-16 rounded-2xl sm:rounded-3xl overflow-hidden w-full">
          <img
            src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/9a8db6ae3a3326ffa24968b2a64c4ce1.jpeg"
            alt="Контекстная реклама — выход на новый уровень"
            className="w-full h-auto block"
          />
        </div>
      </div>
    </section>
  );
}
